import { createAction, handleActions } from 'redux-actions'

const setAdditionalFilter = createAction('SCREENS/PLANNER/SET_ADDITIONAL_FILTER')

const defaultState = {}

const reducer = handleActions(
  {
    [setAdditionalFilter]: (state, { payload }) => payload || {},
  },
  defaultState,
)

export {
  setAdditionalFilter,
  reducer,
}
